import { render, staticRenderFns } from "./PlannerSchedulerEventCard.vue?vue&type=template&id=63fe5251&"
import script from "./PlannerSchedulerEventCard.vue?vue&type=script&lang=js&"
export * from "./PlannerSchedulerEventCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports